module.exports = __webpack_public_path__ + "static/media/15c-04_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.7fd7412e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15c/15c-04_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 166
// module chunks = 0